const Modal = (props) => {
   const { children, onClose } = props;

   return (
      <div tabIndex="-1" style={{ zIndex: 1050 }} className="ps-fixed modal-open">
         <div className="">
            <div className="modal fade show" role="dialog" tabIndex="-1" >
               {children}
            </div>
            <div className="modal-backdrop fade show"></div>
         </div>
      </div>
   )
}

export default Modal;